import { STATUS_STYLES } from "@/lib/api";

export const StatusBadge = ({ status, testId }) => {
  const style = STATUS_STYLES[status] || STATUS_STYLES["En attente"];
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold ${style.badge}`}
    >
      <span className={`h-2 w-2 rounded-full ${style.dot}`} />
      {status}
    </span>
  );
};
